import { Data } from "~/types/dataTypes"
import { RadioQuestion } from "~/types/questionTypes"
import { redcapChoicesToRadioOptions } from "~/util/redcapChoicesToRadioOptions"
import Checkbox from "~/components/Checkbox"

type RadioButtonGroupProps = {
  data: Data
  question: RadioQuestion
  updateFields: (newData: Data) => void
  className?: string
}

export const CheckboxGroup = (props: RadioButtonGroupProps): JSX.Element => {
  const {
    question: { fieldName, selectChoicesOrCalculations },
    data,
    updateFields,
    className
  } = props

  // Initialize as empty array if not set, or parse existing value
  const rawValue = data[fieldName]
  const currentSelectedValues: string[] = rawValue
    ? Array.isArray(rawValue)
      ? rawValue
      : [rawValue]
    : []

  const optionsWithValues = redcapChoicesToRadioOptions(
    selectChoicesOrCalculations
  )

  const handleCheckboxChange = (selectedValues: string[]) => {
    updateFields({ [fieldName]: selectedValues })
  }

  return (
    <div className={`${className} flex flex-col gap-1.5`}>
      <p className="text-sm mb-4">Vælg den valgmulighed der passer bedst</p>
      {optionsWithValues.map(({ label, value }) => (
        <div key={fieldName + value}>
          <Checkbox
            key={fieldName + value}
            name={fieldName}
            label={label}
            value={value}
            selectedValues={currentSelectedValues}
            onChange={handleCheckboxChange}
          />
        </div>
      ))}
    </div>
  )
}
